module.exports = __webpack_public_path__ + "static/media/packDIY.4e1c2140.jpg";